export default __webpack_public_path__ + "static/media/whiteFilterIcon.731a52c5.svg";